import React, { useState } from "react";
import { Form, FormInstance, Row, Col } from "antd";
import FileUploaderWanda from "../../../containers/file-uploader-wanda/FileUploaderWanda";
import styles from "./PersonForm.module.scss";
import defaultImage from "../../../assets/images/uploadPic.svg";
import PhotoUploadErrorModal from "../Modals/PhotoUploadErrorModal";

type Props = {
  form: FormInstance;
};

const PersonPhoto: React.FC<Props> = ({ form }) => {
  const [isPhotoErrorModalVisible, setIsPhotoErrorModalVisible] = useState<
    boolean
  >(false);

  const handleUploadPicture = (file: File) => {
    if (file) {
      form.setFieldsValue({
        photoFile: file,
      });
      const format = file.type.split("/")[1];
      if (format === "jpg" || format === "jpeg" || format === "png") {
        const objectUrl = URL.createObjectURL(file);
        form.setFieldsValue({
          photo: objectUrl,
        });
      } else {
        setIsPhotoErrorModalVisible(true);
      }
    }
  };

  return (
    <>
      <Row className={styles.mobileUploadPhotoAlign}>
        <Col xs={24} lg={18} className={styles.mobileUploadBtnAlign}>
          <Form.Item name="photo" className={styles.formItemMargin}>
            <FileUploaderWanda
              className={styles.uploadPhotoBtn}
              clickHandler={handleUploadPicture}
              filter=".png,.jpg,.jpeg"
              disabled={false}
            >
              Select Photo
            </FileUploaderWanda>
          </Form.Item>
          <label className={styles.fileTypeLabel}>
            Accepted file types: JPG, JPEG, PNG
          </label>
        </Col>
        <Col xs={24} lg={6} className={styles.photoDisplayAlign}>
          <Form.Item
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.photo !== currentValues.photo
            }
          >
            {({ getFieldValue }) => {
              const photoURL = getFieldValue("photo");
              return (
                <img
                  className={styles.image}
                  src={photoURL || defaultImage}
                  alt="preview"
                />
              );
            }}
          </Form.Item>
        </Col>
      </Row>

      <PhotoUploadErrorModal
        visible={isPhotoErrorModalVisible}
        setVisibility={setIsPhotoErrorModalVisible}
      />
    </>
  );
};

export default PersonPhoto;
